import logo from './logo.svg';
import './App.css';
import { useState } from 'react';

import DiceImage1 from "./images/dice-1.png";
import DiceImage2 from "./images/dice-2.png";
import DiceImage3 from "./images/dice-3.png";
import DiceImage4 from "./images/dice-4.png";
import DiceImage5 from "./images/dice-5.png";
import DiceImage6 from "./images/dice-6.png";
import DiceImage7 from "./images/inverted-dice-1.png";
import DiceImage8 from "./images/inverted-dice-2.png";
import DiceImage9 from "./images/inverted-dice-3.png";
import DiceImage10 from "./images/inverted-dice-4.png";
import DiceImage11 from "./images/inverted-dice-5.png";
import DiceImage12 from "./images/inverted-dice-6.png";



function App() {

  var diceImages = [
    DiceImage1,
    DiceImage2,
    DiceImage3,
    DiceImage4,
    DiceImage5,
    DiceImage6,
  ]

  var diceDark =[
    DiceImage7,
    DiceImage8,
    DiceImage9,
    DiceImage10,
    DiceImage11,
    DiceImage12
  ]

  const [image, setNewImage] = useState(diceImages[0])
  const [image2, setNewImage2] = useState(diceDark[1])

  const rollDice = () => {
    //Generate random number
    var randomNum1 = Math.floor(Math.random() * 6);
    var randomNum2 = Math.floor(Math.random() * 6);
    setNewImage(diceImages[randomNum1]);
    setNewImage2(diceDark[randomNum2]);
  }

  return (
    <div className="App">
      <center>
        <h1>Roll the Dice!</h1>
        <div className='container'>
          <img alt='Random Dice for generator' className='square' src={image}></img>
          <div style={{width: '5px', display: 'inline-block'}}></div>
          <img alt='Random Dice for generator' className='square' src={image2}></img>
        </div>
        <button type="button" class="rbtn" onClick={rollDice}>Roll Dice</button>
      </center>
    </div>
  );
}

export default App;
